'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _web3Utils = require('web3-utils');

var _PropTypeBn = require('../utilities/PropTypeBn');

var _roundEth = require('../utilities/roundEth');

var _roundEth2 = _interopRequireDefault(_roundEth);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Display a wei value converted to ETH, with provided suffix.
 * Ensure we've got valid wei before converting.
 */
var FormattedWei = function FormattedWei(_ref) {
  var wei = _ref.wei,
      suffix = _ref.suffix,
      decimals = _ref.decimals;

  if (_web3Utils.BN.isBN(wei)) {
    var eth = (0, _web3Utils.fromWei)(wei);
    var roundededEth = (0, _roundEth2.default)(eth, decimals);
    return eth === roundededEth ? _react2.default.createElement(
      'span',
      null,
      (eth + ' ' + suffix).trim()
    ) : _react2.default.createElement(
      'span',
      { title: (eth + ' ' + suffix).trim() },
      (roundededEth + ' ' + suffix).trim()
    );
  }
  return _react2.default.createElement(
    'span',
    null,
    '--'
  );
};

FormattedWei.displayName = 'FormattedWei';

FormattedWei.defaultProps = {
  wei: null,
  suffix: 'ETH',
  decimals: _constants.DEFAULT_ETH_DECIMALS
};

_PropTypeBn.PropTypeBn.isRequired = _PropTypeBn.PropTypeBnIsRequired;
FormattedWei.propTypes = {
  wei: _PropTypeBn.PropTypeBn,
  suffix: _propTypes2.default.string,
  decimals: _propTypes2.default.number
};

exports.default = FormattedWei;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/FormattedWei.js
// module id = 449
// module chunks = 0